import _ from '../utils'
import rangeSlider from 'rangeslider-pure'
import FORM_RANGE_CONFIG from './config'

class FormRangeClass {
    constructor( range ) {
        this.DOM = {
            range: range,
            input: _.select( 'input', range ),
            dummy: _.select( '.range', range )
        }

        this.range = null
        this.init()
    }

    init() {
        //this._listeners()
        this._create()
        console.log( this )
        console.log( typeof( parseInt( this.DOM.input.max ) ) )
    }

    _create() {
        let THIS = this
        this.range = rangeSlider.create( this.DOM.dummy, {
            min: parseInt( this.DOM.input.min ),
            max: parseInt( this.DOM.input.max ),
            step: parseInt( this.DOM.step ),
            buffer: parseInt( this.DOM.input.buffer ),
            value: 0,
            onSlideEnd: function (position, value) {
                THIS.DOM.input.value = position
            }
        })
    }
    
}

const FORM_RANGE = []
FORM_RANGE_CONFIG.ranges.forEach( ( range ) => { FORM_RANGE.push( new FormRangeClass( range ) ) })
export default FORM_RANGE